module.exports = __webpack_public_path__ + "img/ascend_gold11.84abcf92.png";